export default [
    {   // [0]
        type: "b-form-datepicker",
        margin: true,
        showLabel: true,
        label: "From",
        placeholder: app.$i18n.t("Date"),
        class: "font-small-2",
        model: null,
        locale: "es",
        dateFormatOptions: { year: 'numeric', month: '2-digit', day: 'numeric' },
        cols: 6,
    },
    {   // [1]
        type: "b-form-datepicker",
        margin: true,
        showLabel: true,
        label: "To",
        placeholder: app.$i18n.t("Date"),
        class: "font-small-2",
        model: null,
        locale: "es",
        dateFormatOptions: {
            year: "numeric",
            month: "2-digit",
            day: "numeric",
        },
        cols: 6,
    },
    {   // [2]
        type: "v-select",
        margin: true,
        showLabel: true,
        label: "Personal Type",
        labelName: "text",
        options: [
            { id: 1, text: app.$i18n.t("Employee") },
            { id: 2, text: app.$i18n.t("Driver") },
            { id: 3, text: app.$i18n.t("Third Party") },
            { id: 4, text: app.$i18n.t("Stevedore") },
        ],
        model: null,
        cols: 12,

    },
    {   // [3]
        type: "v-select",
        margin: true,
        showLabel: true,
        label: "entity group",
        options: [],
        model: null,
        cols: 12,

        labelName: "text",
        reduce: "value",
    },
    {   // [4]
        type: "v-select",
        margin: true,
        showLabel: true,
        label: "Status",
        options: [
            { id: 1, text: app.$i18n.t("Active") },
            { id: 2, text: app.$i18n.t("Inactive") },
            { id: 3, text: app.$i18n.t("All") },
        ],
        model: 1,
        cols: 12,
        labelName: "text",
        reduce: "id",
    },
    {   // [5]
        type: "v-select",
        margin: true,
        showLabel: true,
        label: "Areas",
        options: [],
        model: null,
        cols: 12,
        labelName: "name",
        reduce: "id",
    },
];